import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { introTextRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type IntroTextProps = HTMLAttributes<HTMLDivElement> & {
  alignment: 'left' | 'right' | 'center'
  text_alignment: 'left' | 'center'
  title: string
  subtitle: string
}

const IntroText = ({ alignment, text_alignment, title, subtitle, ...props }: IntroTextProps) => {
  return (
    <Motion animation={introTextRevealAnimation}>
      <Section {...props}>
        <Container>
          <Grid>
            <div
              className={cn(
                'col-span-4 flex flex-grow flex-col gap-spacing-sm md:col-span-6 lg:col-span-8',
                alignment === 'left' && 'lg:col-start-1',
                alignment === 'right' && 'lg:col-start-5',
                alignment === 'center' && 'lg:col-start-3',
                text_alignment === 'center' && 'text-center'
              )}
            >
              <Typography variant="h5">{title}</Typography>
              <Typography variant="large" className="font-medium text-text-accent-light-dark">
                {subtitle}
              </Typography>
            </div>
          </Grid>
        </Container>
      </Section>
    </Motion>
  )
}

export default IntroText
